const carouselItems = [
  {
    id: 1,
    title: '2024娱乐圈年度十大塌房事件全盘点',
    desc: '从顶流小生到实力派演员，这一年娱乐圈震动不断。我们为你梳理了最具冲击力的十大塌房事件。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20illustration%20of%20entertainment%20industry%20scandal%20concept%2C%20collapsed%20building%20metaphor%20with%20spotlight%20beams%2C%20warm%20red%20and%20amber%20color%20scheme%2C%20cinematic%20composition%2C%20modern%20digital%20art%20style%2C%20professional%20magazine%20quality%2C%20abstract%20storytelling%20visual&width=1200&height=600&seq=carousel-01-2026&orientation=landscape',
    tag: '年度专题',
  },
  {
    id: 2,
    title: '网红经济泡沫破裂：从年入千万到被封杀的全过程',
    desc: '曾经风光无限的头部网红们，如今面临平台封杀、税务追缴、粉丝流失的多重困境。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20concept%20of%20internet%20economy%20bubble%20bursting%2C%20falling%20numbers%20and%20fading%20screens%2C%20warm%20amber%20and%20red%20tones%2C%20modern%20digital%20art%2C%20minimalist%20composition%2C%20professional%20news%20visual%20style&width=1200&height=600&seq=carousel-02-2026&orientation=landscape',
    tag: '深度报道',
  },
  {
    id: 3,
    title: '综艺节目幕后潜规则大起底：那些你不知道的录制内幕',
    desc: '剪辑操控、剧本安排、嘉宾关系——我们深入调查了热门综艺节目背后不为人知的运作方式。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20editorial%20illustration%20of%20behind%20the%20scenes%20TV%20production%2C%20shadow%20figures%20and%20camera%20equipment%2C%20warm%20dramatic%20lighting%2C%20red%20and%20amber%20accents%2C%20modern%20digital%20art%20style%2C%20cinematic%20atmosphere%2C%20professional%20quality&width=1200&height=600&seq=carousel-03-2026&orientation=landscape',
    tag: '独家揭秘',
  },
  {
    id: 4,
    title: '明星婚姻经济学：从恩爱夫妻到对簿公堂的资产分割战',
    desc: '当爱情变成生意，当婚姻成为筹码。盘点近年最轰动的明星离婚案及其背后的巨额财产分割。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20editorial%20illustration%20of%20divorce%20and%20asset%20division%20concept%2C%20split%20documents%20and%20broken%20rings%2C%20warm%20red%20and%20gold%20tonal%20palette%2C%20modern%20minimalist%20digital%20art%2C%20professional%20magazine%20editorial%20style&width=1200&height=600&seq=carousel-04-2026&orientation=landscape',
    tag: '专题策划',
  },
  {
    id: 5,
    title: '饭圈文化深度观察：从打榜应援到数据造假的灰色产业链',
    desc: '流量时代的粉丝经济已经演变为一条完整的灰色产业链。打榜、控评、刷数据背后到底是谁在操盘？',
    image: 'https://readdy.ai/api/search-image?query=Editorial%20illustration%20of%20social%20media%20manipulation%20and%20fan%20culture%2C%20abstract%20data%20streams%20and%20robot%20accounts%2C%20warm%20red%20and%20amber%20lighting%2C%20modern%20digital%20art%2C%20clean%20composition%2C%20professional%20news%20visual&width=1200&height=600&seq=carousel-05-2026&orientation=landscape',
    tag: '行业分析',
  },
  {
    id: 6,
    title: '华语乐坛抄袭风波全记录：从编曲到MV的相似度对比',
    desc: '近期多首热门歌曲陷入抄袭争议，我们整理了完整的对比分析，用事实说话。',
    image: 'https://readdy.ai/api/search-image?query=Abstract%20musical%20notes%20and%20waveform%20comparison%20editorial%20illustration%2C%20overlapping%20sound%20waves%2C%20warm%20red%20and%20amber%20color%20scheme%2C%20modern%20digital%20art%20style%2C%20professional%20magazine%20quality%2C%20clean%20minimalist%20composition&width=1200&height=600&seq=carousel-06-2026&orientation=landscape',
    tag: '对比分析',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 text-center mb-10 font-heading">
          重磅专题
        </h2>
        <div className="overflow-x-auto pb-4 scrollbar-hide">
          <div className="flex gap-5 md:gap-6" style={{ minWidth: 'max-content' }}>
            {carouselItems.map((item) => (
              <div
                key={item.id}
                className="flex-shrink-0 w-[320px] md:w-[380px] bg-background-50 border border-secondary-200/60 rounded-xl overflow-hidden hover:border-primary-200/60 transition-colors cursor-pointer group"
              >
                <div className="relative h-44 md:h-52 overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} - 五一黑料网重磅专题`}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500 object-top"
                    width="1200"
                    height="600"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="px-2.5 py-1 bg-primary-500 text-background-50 text-xs font-medium rounded-md whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                </div>
                <div className="p-4 md:p-5">
                  <h3 className="text-base font-bold text-foreground-900 mb-2 line-clamp-2 font-heading group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-center mt-6">
          <span className="flex items-center gap-2 text-sm text-foreground-400">
            <i className="ri-arrow-left-right-line"></i>
            左右滑动浏览更多专题
          </span>
        </div>
      </div>
    </section>
  );
}